export const CAL_BOOKING_URL = "https://cal.com/inalign-wellness-vhllaf/discovery-call";
export const FACEBOOK_URL = "https://www.facebook.com/profile.php?id=61574635635986";
export const INSTAGRAM_URL = "https://www.instagram.com/inalign_wellness";
export const GUIDE_DOWNLOAD_URL = "/The-Discipline-Code.pdf";
